export default "__VITE_ASSET__BAkxxF3F__"